exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tabBarTabButton{width:100%;height:100%;padding:0;border:none;margin:0;background:none;font:inherit}", ""]);

